import { Box } from '@material-ui/core';
import { useObserver } from 'mobx-react-lite';
import React, { FC } from 'react';
import {
  KioskOrderingStore,
  OnlineOrder,
  OnlineOrderingStore
} from 'kiolyn-api';
import AmountRow from './AmountRow';
import { useOrdering } from '../../../stores/OrderingStore';
import { getApplyTax } from '../../../domain/usecases/KioskApplyTax';

const OrderSummary: FC<{ order: OnlineOrder; store?: OnlineOrderingStore }> = ({
  order,
  store
}) => {
  const discountAmount = order.discount_amount ?? 0;
  const discountName = order.discount?.name ?? '';
  const taxPercent = order.tax?.percent ?? 0;
  const taxName = order.tax?.name ?? '';
  const customFeeName = order.custom_fee?.name ?? '';
  const customFeeAmount = order.custom_fee?.amount ?? 0;
  const deliveryFee = order.delivery_fee_amount ?? 0;
  const tip = order.tip ?? 0;
  const total = order.total ?? 0;
  const isEstimatedDelivery = order.quote_id && order.quote_id.length > 0;
  const isSplitTip =
    order.order_type === 'delivery' &&
    order.tip_for_driver &&
    order.tip_for_restaurant_staff;

  const orderingStore: KioskOrderingStore = store ?? useOrdering().store;
  const isApplyTax = getApplyTax(orderingStore);

  return useObserver(() => (
    <Box>
      <AmountRow name="Subtotal" amount={order.subtotal} />
      {discountAmount > 0 && (
        <AmountRow name={discountName} amount={-discountAmount} />
      )}
      {deliveryFee > 0 && (
        <AmountRow
          name={
            isEstimatedDelivery ? 'Delivery fee (estimated)' : 'Delivery fee'
          }
          amount={deliveryFee}
        />
      )}
      {isApplyTax && taxPercent > 0 && (
        <AmountRow
          name={`${taxName} (${(taxPercent * 100).toFixed(3)}%)`}
          amount={order.tax_amount}
        />
      )}
      {customFeeAmount > 0 && (
        <AmountRow name={customFeeName} amount={customFeeAmount} />
      )}
      {tip > 0 &&
        (isSplitTip ? (
          <>
            <AmountRow name="Tip for driver" amount={order.tip_for_driver} />
            <AmountRow
              name="Tip for staff"
              amount={order.tip_for_restaurant_staff}
            />
          </>
        ) : (
          <AmountRow name="Tip" amount={tip} />
        ))}
      <AmountRow name="TOTAL" amount={total} variant="h6" />
    </Box>
  ));
};

export default OrderSummary;
